/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { EventType, LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  type?: EventType;
  disabledFields: string[];
}

const ResultsItem: FunctionComponent<IProps> = ({ result, disabledFields }) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };

  console.log(isEnabled(result.isCBScoreBE ? 'totalCBScoreBE' : 'totalCBScore'));

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>
        {isEnabled('bridleNumber') && (
          <div className="fw-7">{result.bridleNumber}</div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center">
          <img src={helmetIcon} className="mr-11 tablet-hidden" alt="" />
          <div className="fs-12 fw-7">
            {result.riderFirstName} {result.riderLastName}
          </div>
        </div>
        <div className="fs-12 tablet-visible">{result.horseName}</div>
      </td>
      <td>
        <div className="d-flex align-items-center tablet-hidden">
          <img src={horseIcon} className="mr-11 tablet-hidden" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7">{result.horseName}</div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}
            </div>
          </div>
        </div>
      </td>
      <td className="mobile-hidden">
        {isEnabled('dressageTime') && result.dressageTime}
      </td>
      <td className="mobile-hidden">
        {isEnabled('showJumpingTime') && result.showJumpingTime}
      </td>
      <td className="mobile-hidden">
        {isEnabled('dressageScore') && result.dressageScore?.toFixed(2)}
      </td>
      <td className="mobile-hidden">
        {isEnabled('sjPenalties') && result.sjPenalties}
      </td>
      <td className="mobile-hidden">
        {isEnabled('dressageCollective') &&
          result.dressageCollective?.toFixed(2)}
      </td>
      <td className="mobile-hidden">
        {isEnabled('eaDressagePercentageCustom') &&
          result.eaDressagePercentageCustom?.toFixed(3)}
      </td>
      <td>
        {isEnabled(result.isCBScoreBE ? 'totalCBScoreBE' : 'totalCBScore') &&
          (result.isCBScoreBE
            ? result.totalCBScoreBE?.toFixed(2)
            : result.totalCBScore?.toFixed(2))}
      </td>
      <td>{isEnabled('sectionPlace') && result.sectionPlace}</td>
      <td>{isEnabled('overallPlace') && result.overallPlace}</td>
      <td>
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">
            {result.riderClassStatusCode}
          </div>
        )}
      </td>
    </tr>
  );
  // return (
  //   <StyledCard ref={ref} className="mt-10 mb-10">
  //     <div className="card-body">
  //       <div className="row">
  //         <div className="col-2">
  //           {isEnabled('bridleNumber') && (
  //             <>
  //               <div className="fw-7">{result.bridleNumber}</div>
  //               <div className="txt txt-secondary fs-11">Rider/BN</div>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-7">
  //           {isEnabled('eaEventClassAndSort') && (
  //             <>
  //               <div className="txt">{result.eaEventClassAndSort}</div>
  //               <div className="txt txt-secondary fs-11">Class</div>
  //             </>
  //           )}
  //           {isEnabled('sectionName') && (
  //             <>
  //               <div className="txt mt-15">{result.sectionName}</div>
  //               <div className="txt txt-secondary fs-11">Section</div>
  //             </>
  //           )}
  //           <div className="d-flex mt-15">
  //             <img src={helmetIcon} className="mr-11" alt="" />
  //             <div className="fs-12 fw-7">
  //               {result.riderFirstName} {result.riderLastName}
  //             </div>
  //           </div>
  //           <div className="d-flex align-items-center">
  //             <img src={horseIcon} className="mr-11" alt="" />
  //             <div>
  //               <div className="fs-12 fw-7">{result.horseName}</div>
  //               <div className="fs-12">
  //                 Owner: {result.ownerFirstName} {result.ownerLastName}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="col-3 txt-right">
  //           {isEnabled('riderClassStatusCode') && (
  //             <>
  //               <p className="txt fw-7 txt-accent name">
  //                 {result.riderClassStatusCode}
  //               </p>
  //               <p className="txt txt-secondary fs-11">Status</p>
  //             </>
  //           )}
  //           <div className="d-inline-flex flex-column mt-15">
  //             {isEnabled('overallPlace') && (
  //               <Badge>OP {result.overallPlace}</Badge>
  //             )}
  //             {isEnabled('sectionPlace') && (
  //               <Badge className="mt-5">SP {result.sectionPlace}</Badge>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //       <div className="row">
  //         <div className="col-2"></div>
  //         <div className="col-2">
  //           {isEnabled('showJumpingTime') && (
  //             <>
  //               <p className="txt fw-7 mt-15">{result.showJumpingTime}</p>
  //               <p className="txt txt-secondary fs-11">SJ Time</p>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-2">
  //           {isEnabled('dressageTime') && (
  //             <>
  //               <p className="txt mt-15 fw-7">{result.dressageTime}</p>
  //               <p className="txt txt-secondary fs-11">DR Time</p>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-2">
  //           {isEnabled('totalCBScore') && (
  //             <>
  //               <p className="txt mt-15 fw-7">
  //                 {result.totalCBScore?.toFixed(2)}
  //               </p>
  //               <p className="txt txt-secondary fs-11">Score</p>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-2">
  //           {isEnabled('dressageCollective') && (
  //             <>
  //               <p className="txt mt-15 fw-7">
  //                 {result.dressageCollective?.toFixed(2)}
  //               </p>
  //               <p className="txt txt-secondary fs-11">Colls</p>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-2">
  //           {isEnabled('eaDressagePercentageCustom') && (
  //             <>
  //               <p className="txt mt-15 fw-7">
  //                 {result.eaDressagePercentageCustom?.toFixed(3)}
  //               </p>
  //               <p className="txt txt-secondary fs-11">%</p>
  //             </>
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   </StyledCard>
  // );
};

export default memo(ResultsItem);
